import script from "./FormFiltroSelecao.vue?vue&type=script&setup=true&lang=js"
export * from "./FormFiltroSelecao.vue?vue&type=script&setup=true&lang=js"

import "./FormFiltroSelecao.vue?vue&type=style&index=0&id=752a72be&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-752a72be"]])

export default __exports__